<script>
import HasForm from '@/components/forms/has-form';

export default {
  name: 'popups.distribution-group.create-or-update',

  mixins: [HasForm],

  components: {
    ElForm: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElForm'),
    ElInput: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElInput'),
  },

  props: {
    action: {
      type: String,
      required: true,
      validator: function(value) {
        return ['create', 'update'].indexOf(value) !== -1;
      },
    },
  },

  data: () => ({
    payload: {
      title: '',
      subtitle: '',
    },
  }),

  mounted() {
    if (this.action === 'update') {
    }
  },

  methods: {
    async submit() {
      this.loading = true;

      await this.$store.dispatch('distributionGroup/create', {
        workspace_id: this.workspace.id,
        group: this.payload,
      });

      this.handleSuccess();

      this.$emit('close');

      this.loading = false;
    },
  },

  computed: {
    workspace() {
      return this.$store.getters['workspace/current'];
    },
  },
};
</script>

<template>
  <div class="popup">
    <div class="popup-header">
      <p class="mb-0 fs-17 fw-b">
        <i class="fal fa-folder-plus mr-8"></i>
        {{ $t(`${$options.name}.title_${action}`) }}
      </p>
      <div class="close" @click="$emit('close')"></div>
    </div>
    <div class="popup-content pt-0">
      <el-form class="w-100" @submit="submit()" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button_${action}`">
        <div class="form-row mb-30">
          <el-input v-model="payload.title" class="col-12" rule="required|min:2|max:255" name="distribution_group_title" />
          <el-input v-model="payload.subtitle" class="col-12" rule="min:2|max:255" name="distribution_group_subtitle" />
        </div>

        <template #footerLeft>
          <span class="btn btn-outline-primary ml-auto" @click="$emit('close')">{{ $t('general.cancel') }}</span>
        </template>
      </el-form>
    </div>
  </div>
</template>
